import { render, staticRenderFns } from "./bpo.vue?vue&type=template&id=6beea965&scoped=true&"
import script from "./bpo.vue?vue&type=script&lang=js&"
export * from "./bpo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beea965",
  null
  
)

export default component.exports